/** Sign out, as a POST.
 *
 * Three menus offer this — the desk top bar, the administration top bar and the
 * portal — and all three used to be `<a href="/oidc/logout/">`. That is a GET,
 * and `mozilla_django_oidc.OIDCLogoutView` answers GET with 405 unless
 * `ALLOW_LOGOUT_GET_METHOD` is switched on. Every sign-out button in the product
 * was returning "HTTP ERROR 405".
 *
 * The fix is the POST, not the setting. Logging someone out is a state change,
 * and a state change reachable by GET can be fired by anything that can make the
 * browser issue one — an `<img src="/oidc/logout/">` in a ticket description
 * would sign out whoever opened the ticket. Turning the setting on would have
 * been one line and would have kept that hole open.
 *
 * One component rather than three copies of the same form: the next person to
 * change how logout works should have one place to change it.
 */
import { LogOut } from 'lucide-react'

import { csrfToken } from '../lib/api'
import { DropdownMenuItem } from './ui/primitives'

export function SignOutItem() {
  return (
    // `asChild` puts the menu item's styling on the form's button, so this row
    // looks and behaves exactly like the links it replaced.
    <DropdownMenuItem asChild>
      <form method="post" action="/oidc/logout/">
        {/* Django checks this against the cookie. The cookie is not HttpOnly —
            by design, since the fetch client reads it the same way. */}
        <input type="hidden" name="csrfmiddlewaretoken" value={csrfToken()} />
        <button type="submit" className="flex w-full items-center gap-2">
          <LogOut />
          Sign out
        </button>
      </form>
    </DropdownMenuItem>
  )
}
